import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { SvgIcon } from '@/components';

import styles from './RefundNote.module.sass';

interface RefundNoteProps {
  className?: string;
}

export const RefundNote = ({ className }: RefundNoteProps) => {
  const { t } = useTranslation();

  return (
    <div className={cx(styles.note, className)}>
      <span className={styles.iconTile} aria-hidden="true">
        <SvgIcon name="refund" className={styles.icon} />
      </span>
      <div className={styles.text}>
        <span className={styles.lead}>
          {t('translation.refund_guarantee_title')}
        </span>{' '}
        {t('translation.refund_guarantee_text')}
      </div>
    </div>
  );
};
